<script>
/*eslint-disable */
import NProgress from "nprogress";
import Axios from "axios";
import Email from "../../../components/auth/Email.vue";

export default {
  name: "ForgotCcnsw",
  components: {
    Email
  },
  data() {
    return {
      userEmail: "",
      isCheckEmail: true
    };
  },
  methods: {
    sendForgotRequest() {
      NProgress.start();
      Axios({url: '/ir/auth/forgot/username', data: {email: this.userEmail}, method: 'POST'})
          .then(resp => {
            this.isCheckEmail = !(resp && resp.data && resp.data.status === false);
            if (this.isCheckEmail) this.$router.push('/login');
          })
          .catch(err => {
            console.log(err);
          }).finally(() => {
        NProgress.done();
      });
    },
    goToHome() {
      document.location.replace('/login');
      // this.$router.push('/');
    },
  }
};
</script>

<template>
  <div class="container-fluid page">
    <div class="content">
      <div class="background column">
        <div style="width: 694px"></div>
      </div>
      <div class="form-container column">
        <div class="form" style="bottom: 70px">
          <div class="">
            <div class="logo">
            </div>
          </div>
          <form method="POST">
            <div>
              <img src="@/assets/logos/accident-repair-centres-logo.jpg" class="accident-logo"/>
              <span class="close" @click.prevent="goToHome">×</span>
            </div>
            <h2 class="header-text">Forgot your Username?</h2>
            <p>Dont’ worry, just enter the email address your account is registered with and we will send you
              your username</p>
            <br/>
            <div class="form-group">
              <label for="userEmail">Email Address</label>
              <email v-model="userEmail"></email>
              <p>
                Get Help with your username.
                <router-link class="blue-theme" :to="{name: 'SupportUserNamePage'}">Click here</router-link>
              </p>
            </div>

            <div class="form-group">
              <button :disabled="!isCheckEmail || !userEmail"
                      type="button"
                      @click="sendForgotRequest"
                      class="btn input-btn">Send Me My Username
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<style>
@import "../../../styles/login/style.css";
</style>

<style scoped>
.close{
  cursor: pointer;
}
.blue-theme{
  color: #00529C;
}
.blue-theme:hover{
  color: #013c72;
}
.input-btn:disabled:hover{
  background-color: #ccc;
}
.input-btn{
  background-color: #00529C;
}
.input-btn:hover{
  background-color: #013c72;
  color: white;
}
.accident-logo{
  height: 100px;
  margin-bottom: 70px;
}
.page {
  height: 100vh;
}

@media screen and (max-width: 768px) {
  .page .content {
    height: 100%;
  }
  .page .content .form-container {
    height: 100%;
  }
  .page .form {
    height: 100%;
  }
  .page .form form {
    display: flex;
    flex-direction: column;
    height: 80%;
    justify-content: center;
  }
}
</style>
